// RefreshErrorBanner — the inline "couldn't REFRESH" banner shown when a background
// re-fetch fails but a last-good list is still on screen (so it's a banner, not a
// full ErrorState). Shared by the Gallery and the Look library, which had byte-identical
// copies. The caller passes its own `className` so existing styling is preserved.

export interface RefreshErrorBannerProps {
  /** The failure cause, appended after "Couldn't refresh: ". */
  message: React.ReactNode;
  /** Re-run the failed fetch. */
  onRetry: () => void;
  /** The host's existing banner class (e.g. "gallery__error") — drives the styling. */
  className: string;
  testId?: string;
}

export function RefreshErrorBanner({
  message,
  onRetry,
  className,
  testId,
}: RefreshErrorBannerProps): React.JSX.Element {
  return (
    <p className={className} role="alert" data-testid={testId}>
      Couldn’t refresh: {message}{" "}
      <button type="button" className="btn" onClick={onRetry}>
        Retry
      </button>
    </p>
  );
}
